// extracted by mini-css-extract-plugin
module.exports = {"video_player":"jH1GH","videoPlayer":"jH1GH","video_container":"_2_JZo","videoContainer":"_2_JZo"};